import React from 'react';

import { BaseComponent } from '../Component';

import styles from './EvoachLogo.module.css';

export interface EvoachLogoComponent extends BaseComponent {
  type: 'evoachLogoDisplay';
  props: EvoachLogoProps;
}

export interface EvoachLogoProps {
  width?: number;
  height?: number;
}

export const EvoachLogo: React.FC<EvoachLogoProps> = ({ width, height }) => {
  if (!height) height = width;
  if (!width) width = height;

  return width ? (
    <div
      className={styles['s512']}
      style={{
        backgroundSize: width + 'px ' + height + 'px',
        width: width,
        height: height,
      }}
    />
  ) : (
    <div className={styles['s512']} />
  );
};
